import {ChartOptions} from 'chart.js';

export const CHART_OPTION_STACKED_AND_RESPONSIVE: Partial<ChartOptions> = {
  responsive: true,
  scales: {
    x: {
      stacked: true
    },
    y: {
      stacked: true
    }
  },
};

export const CHART_OPTION_DEFAULT_PLUGIN: Partial<ChartOptions> = {
  plugins: {
    datalabels: {
      formatter: (value) => {
        return `${value}`;
      },
      anchor: 'end',
      align: 'end',
    }
  }
};


export const CHART_OPTION_STACKED_BARCHART_PLUGIN: Partial<ChartOptions> = {
  plugins: {
    datalabels: {
      formatter: (value) => {
        return `${value}`;
      },
      anchor: 'center',
      align: 'center',
      display: 'auto',
    }
  }
};

export const chartColors = [
  '#ffa1b7',
  '#5bc8f5',
  '#ffe398',
  '#f1f2f4',
  '#67dbda',
  '#b9d7e2',
  '#DD44776C',
  '#3366CC6C',
  '#FF99006C',
  '#1096186C',
  '#DC39126C',
  '#9900996C',
  '#ebebeb',
  '#3B3EAC6C',
  '#0099C66C',
  '#66AA006C',
  '#B82E2E6C',
  '#3163956C',
  '#9944996C',
  '#22AA996C',
  '#AAAA116C',
  '#949aa2',
  '#6633CC6C',
  '#E673006C',
  '#8B07076C',
  '#3292626C',
  '#5574A66C',
  '#6510676C']
;
